module.exports = function(file) {
	var data = file.data || '';
	var filename = file.name || file.filename || 'download.txt';

	if (window.navigator.msSaveBlob) {
		// var blob = new Blob([data],{ type: "application/octet-stream;charset=utf-8;" });
		var blob = new Blob([data],{ type: "text/plain;charset=utf-8;" });
		navigator.msSaveBlob(blob, filename);
		return;
	}

	var link = document.createElement('a');
	// link.setAttribute('href', 'data:application/octet-stream,' + encodeURIComponent(data));
	link.setAttribute('href', 'data:text/plain,' + encodeURIComponent(data));
	link.setAttribute('download', filename);

	link.style.display = 'none';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
